<template>
  <section class="service-section py-5">
    <div class="container-fluid"> <!-- 🔹 Made the container wider -->
      <!-- Heading -->
      <h2 class="text-center mb-4">How can we help you?</h2>

      <!-- Service Row with Images -->


      <div class="row justify-content-center text-center">

          <!-- New Remodeling Service -->
              <div class="col-lg-3 col-md-4 col-sm-6 service-item">
                <img src="/assets/stocks/remodeling.jpg" alt="Remodeling Service" class="service-img"/>
                <div class="text-content">
                  <h5 class="service-title">Remodeling</h5>
                  <p>Upgrade your home with expert remodeling services. We specialize in kitchens, bathrooms, and full home renovations.</p>
                </div>
              </div>
        <!-- Painting Service -->
        <div class="col-lg-3 col-md-4 col-sm-6 service-item">
          <img src="/assets/stocks/painting.jpg" alt="Painting Service" class="service-img"/>
          <div class="text-content">
            <h5 class="service-title">Painting</h5>
            <p>High-quality painting services for residential and commercial properties. Transform your space with vibrant colors!</p>
          </div>
        </div>

        <!-- Repairs Service -->
        <div class="col-lg-3 col-md-4 col-sm-6 service-item">
          <img src="/assets/authentic/sink.jpg" alt="Repairs Service" class="service-img"/>
          <div class="text-content">
            <h5 class="service-title">Repairs</h5>
            <p>Expert repair services for any issues around your home or office. We fix everything from leaky pipes to damaged walls.</p>
          </div>
        </div>

        <!-- Cleaning Service -->
        <div class="col-lg-3 col-md-4 col-sm-6 service-item">
          <img src="/assets/stocks/cleaning.jpg" alt="Cleaning Service" class="service-img"/>
          <div class="text-content">
            <h5 class="service-title">Cleaning</h5>
            <p>Professional cleaning services to keep your space spotless. We handle everything from deep cleans to regular maintenance.</p>
          </div>
        </div>


      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServicesSection'
}
</script>

<style scoped>
.service-section {
  background-color: #f9f9f9;
  padding: 40px 0;
}

/* 🔹 Made container wider */
.container-fluid {
  max-width: 95%;
}

/* Ensures all service images are uniform */
.service-img {
  width: 100%;
  max-width: 270px; /* Increased width */
  height: 200px; /* Increased height */
  object-fit: cover;
  border-radius: 8px;
}

/* Makes sure each service item is aligned properly */
.service-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

/* Centers text under each service */
.text-content {
  text-align: center;
  max-width: 90%;
  margin-top: 10px;
}

/* Ensures all titles are the same size */
.service-title {
  font-size: 20px;
  margin-top: 15px;
  min-height: 30px;
}

/* Styles for descriptions */
.service-section p {
  font-size: 14px;
  color: #555;
}

/* 🔹 Responsive Adjustments */
@media (max-width: 992px) {
  .service-img {
    max-width: 240px; /* Slightly smaller images on medium screens */
    height: 180px;
  }
}

@media (max-width: 768px) {
  .row {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .col-md-4, .col-sm-6 {
    width: 50%; /* Two services per row on smaller screens */
  }

  .service-img {
    max-width: 200px; /* Smaller images for mobile */
    height: 160px;
  }
}

@media (max-width: 576px) {
  .col-md-4, .col-sm-6 {
    width: 100%; /* Full width on extra small screens */
  }

  .service-img {
    max-width: 180px;
    height: 150px;
  }
}
</style>
